import React, {Fragment, useState, useEffect} from 'react';
import Header from './components/Header';
import Formulario from './components/Formulario';
import ListadoNoticias from './components/ListadoNoticias'


function App() {

  //definir la categoria y noticias
  const [categoria, guardarCategoria] = useState('');
  const [noticias, guardarNoticias] = useState([])

  //usamos useeffect para cuando cambie de categoria, muestre esa info

  useEffect(()=>{
    const consultarAPI = async () => {
      const url = `https://gnews.io/api/v4/top-headlines?country=ar&topic=${categoria}&lang=es&token=2fce88705d14ee8587ec20b6f4ad44f9`;

      const respuesta = await fetch(url);
      const noticias = await respuesta.json();

      guardarNoticias(noticias.articles);
      console.log(respuesta);
    }
    consultarAPI();
    
  }, [categoria])




  return (
    <Fragment>
  
    <Header
      titulo={'Buscador de Noticias'}
    />

    <div className="container white">
      <Formulario
        guardarCategoria= {guardarCategoria}
      />

      <ListadoNoticias
        noticias={noticias}
      />
    </div>

    </Fragment>
  );
}

export default App;
